/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingPerformance
 */
export interface RecordingPerformance {
    /**
     * 
     * @type {string}
     * @memberof RecordingPerformance
     */
    featuredStatus?: string | null;
}

/**
 * Check if a given object implements the RecordingPerformance interface.
 */
export function instanceOfRecordingPerformance(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecordingPerformanceFromJSON(json: any): RecordingPerformance {
    return RecordingPerformanceFromJSONTyped(json, false);
}

export function RecordingPerformanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingPerformance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
    };
}

export function RecordingPerformanceToJSON(value?: RecordingPerformance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'featuredStatus': value.featuredStatus,
    };
}

